import styled from 'styled-components';
import { MenuMore, MenuItem, MenuItemText } from '@plataforma/components';

export const Menu = styled(MenuMore)``;
export const Item = styled(MenuItem)``;
export const MenuText = styled(MenuItemText)``;
